import Home from './pages/Home.svelte'
import Venues from './pages/Venues.svelte'
import Athlete from './pages/Athlete.svelte'
import Challenge from './pages/Challenge.svelte'
// import Private from './pages/Private.svelte'
// import Login from './pages/Login.svelte'
import Error from './pages/Error.svelte'

export default [
  {
    path: '/',
    component: Home
  },
  {
    path: '/:e/:a',
    component: Home
  },
  {
    path: '/venues',
    component: Venues
  },
  {
    path: '/challenge',
    component: Challenge
  },
  {
    path: '/athlete/:id/:name/:surname',
    component: Athlete
  },
//   {
//     path: '/blog',
//     component: Blog
//   },
//   {
//     path: '/blog/:id',
//     component: Article
//   },
  // {
  //   path: '/private',
  //   component: Private,
  //   auth: true
  // },
  // {
  //   path: '/login',
  //   component: Login
  // },
  {
    path: '*',
    component: Error
  }
]